import { spawn } from 'redux-saga/effects';

import requestSagas from './request/requestSagas';
import systemStatusSagas from './systemStatus/systemStatusSagas';

export default function* supportSagas() {
	yield spawn(requestSagas);
	yield spawn(systemStatusSagas);
}
